import { createApp } from 'vue'
import { AstraScrollUp } from '@platform/astra-vue'
// import '@platform/astra-vue/dist/astra-vue.mjs.css'

export const createScrollUp = () => {
  return createApp(AstraScrollUp).mount('#scroll-up-component')
}
